import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea937972"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLOrderGeneral" }
const _hoisted_2 = { class: "FTLOrderGeneral__container" }
const _hoisted_3 = { class: "container__block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Основная информация", -1))
const _hoisted_5 = { class: "block__content" }
const _hoisted_6 = { class: "block__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Авто", -1))
const _hoisted_8 = { class: "field__value" }
const _hoisted_9 = {
  key: 0,
  class: "fas fa-check text-green-500"
}
const _hoisted_10 = {
  key: 1,
  class: "fas fa-times text-red-500"
}
const _hoisted_11 = { class: "block__field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер заявки", -1))
const _hoisted_13 = { class: "field__value" }
const _hoisted_14 = { class: "block__field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, " Номер накладной заказчика ", -1))
const _hoisted_16 = { class: "field__value" }
const _hoisted_17 = { class: "block__field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Тип перевозки", -1))
const _hoisted_19 = { class: "field__value" }
const _hoisted_20 = { class: "block__field" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Дата забора", -1))
const _hoisted_22 = { class: "field__value" }
const _hoisted_23 = { class: "block__field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер АВР Spark", -1))
const _hoisted_25 = { class: "field__value" }
const _hoisted_26 = { class: "block__field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Дата АВР", -1))
const _hoisted_28 = { class: "field__value" }
const _hoisted_29 = { class: "block__field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Отработанные часы для выставления", -1))
const _hoisted_31 = { class: "field__value" }
const _hoisted_32 = { class: "block__field" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Количество авто", -1))
const _hoisted_34 = { class: "field__value" }
const _hoisted_35 = { class: "block__field" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Менеджер", -1))
const _hoisted_37 = { class: "field__value" }
const _hoisted_38 = { class: "block__field" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Логист", -1))
const _hoisted_40 = { class: "field__value" }
const _hoisted_41 = { class: "block__field" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Заявка Логиста", -1))
const _hoisted_43 = { class: "field__value" }
const _hoisted_44 = { class: "container__block" }
const _hoisted_45 = { class: "block__content" }
const _hoisted_46 = { class: "block__field" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Клиент", -1))
const _hoisted_48 = { class: "field__value" }
const _hoisted_49 = { class: "block__field" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Описание", -1))
const _hoisted_51 = { class: "field__value" }
const _hoisted_52 = { class: "block__field" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Дата создания", -1))
const _hoisted_54 = { class: "field__value" }
const _hoisted_55 = { class: "block__field" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Кто принял груз", -1))
const _hoisted_57 = { class: "field__value" }
const _hoisted_58 = { class: "block__field" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Дата доставки", -1))
const _hoisted_60 = { class: "field__value" }
const _hoisted_61 = { class: "block__field" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Отработанные часы для себестоимости", -1))
const _hoisted_63 = { class: "field__value" }
const _hoisted_64 = { class: "block__field" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Кто создал заказ", -1))
const _hoisted_66 = { class: "field__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_ctx.isNeedCar)
                ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                : (_openBlock(), _createElementBlock("i", _hoisted_10))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.ftlBidId || '-') + " (" + _toDisplayString(_ctx.ftlTypeName || '-') + ") ", 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.dopOrderNumber || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.shipmentTypeName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.formatDateFromBackend(_ctx.takeDate)) + ", " + _toDisplayString(_ctx.takeTime), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.actNumber || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.actCreatedAt) || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.autoDurationClient || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.autoCount || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              (_ctx.manager)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.manager.email || '-'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" - ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              (_ctx.logist)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.logist.email || '-'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" - ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              (_ctx.logistBidId)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: `/bids/${_ctx.logistBidId}`,
                    class: "text-blue-500",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.logistBidId), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" - ")
                  ], 64))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.companyName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.annotation || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.createdAt) || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.receivedBy || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.deliveryDate) || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.autoDuration || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_64, [
            _hoisted_65,
            _createElementVNode("div", _hoisted_66, [
              (_ctx.createdBy)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.createdBy.email || '-'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" - ")
                  ], 64))
            ])
          ])
        ])
      ])
    ])
  ]))
}